module.exports = __webpack_public_path__ + "static/media/poker-back.579802db.png";